export enum UserProfileEnum {
  PORTAL_VISA = 1030,
  PORTAL_VISA_ROLE = 'PORTAL-VISA',
  PORTAL_STRUCTURE_ROLE = 'PORTAL-STRUCTURE',
  PORTAL_STRUCTURE = 1032,
  PORTAL_CONTACT = 1033,
  PORTAL_CONTACT_ROLE = 'PORTAL-CONTACT',
}
